import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { CLIENTS } from '../../constants/tableTypes'
import { STORE_SELECTED_CLIENT_ROW } from '../../constants/actionTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const clientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_SELECTED_CLIENT_ROW:
      return {
        ...state,
        content: action.rowData[action.rowIndex],
      }
    default:
      return reducers.dataTable.tableFetchReducer(CLIENTS, state, action)
  }
}

export default combineReducers({
  data: clientsReducer,
  tableInfo: tableReducer,
})

export { initialState, clientsReducer }
